import React from 'react';
import T from 'prop-types';

import Button from '../../../Buttons/Button';
import Tooltip from '../../../Tooltip';

const FormActions = ({
  formMode,
  isSubmitDisabled = false,
  isSaveDisabled = false,
  isModal,
  onSubmit,
  onOpenModalConfirm,
  onOpenNameModal,
}) => (
  <div className="global-upsert-export-modal__footer-buttons">
    {formMode === 'update' && (
      <Button
        disabled={isSubmitDisabled}
        onClick={onOpenModalConfirm}
      >
        Generate Export
      </Button>
    )}
    {formMode === 'create' && (
      <>
        <Button
          disabled={isSubmitDisabled}
          onClick={() => onSubmit({ action: 'create', one_time: true, should_redirect: !isModal })}
        >
          Generate Export
        </Button>
        <Tooltip
          content={isSaveDisabled && 'Advanced export settings cannot be saved during your trial period. You can continue with a one-time export by using the \'Generate Export\''}
          wrapChildrenInHtmlNode
        >
          <Button
            variant="secondary"
            disabled={isSubmitDisabled || isSaveDisabled}
            onClick={onOpenNameModal}
          >
            Generate & Save Export Settings
          </Button>
        </Tooltip>
      </>
    )}
  </div>
);

FormActions.propTypes = {
  formMode: T.string,
  isSubmitDisabled: T.bool,
  onSubmit: T.func.isRequired,
  isSaveDisabled: T.bool,
  isModal: T.bool,
  onOpenModalConfirm: T.func.isRequired,
  onOpenNameModal: T.func.isRequired,
};

export default FormActions;
